// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2eYGu","sendOtp":"AuthorizeToLogin_sendOtp__3rO1b"};